var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConClutchIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.553,
    height: 24,
    viewBox: "0 0 21.553 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "con_clutch_icn",
    transform: "translate(570.294 -5555.544)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20161",
    "data-name": "Path 20161",
    d: "M64.287,22.553a6.918,6.918,0,0,1-4.636,1.694,6.574,6.574,0,0,1-6.814-6.75,6.427,6.427,0,0,1,6.814-6.63,7.093,7.093,0,0,1,4.667,1.665l.857.727,3.809-3.753-.953-.848a12.567,12.567,0,0,0-8.382-3.114c-7.061,0-12.189,5.023-12.189,11.925A11.879,11.879,0,0,0,59.649,29.543,12.433,12.433,0,0,0,68.093,26.4l.921-.848L65.146,21.8Z",
    transform: "translate(-617.754 5550)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20162",
    "data-name": "Path 20162",
    d: "M66.194,13.438a4.043,4.043,0,1,1-4.043,4.043,4.043,4.043,0,0,1,4.043-4.043",
    transform: "translate(-624.386 5550.07)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConClutchIcn);
export default __webpack_public_path__ + "static/media/con_clutch_icn.3e52ded357fb15222e856fb3df83fd13.svg";
export { ForwardRef as ReactComponent };